import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
     isFollowEnterprise: false,
     lang: sessionStorage.getItem("lang") || 'CN'
  },
  mutations: {
    // setIsFollowEnterprise(state,boolean) {
    //   console.log("isFollowEnterprise",boolean)
    //   state.isFollowEnterprise = boolean
    // }
  },
  actions: {
  },
  modules: {
  }
})
